import { Button } from "@ac-expo/ui-components";
import { CartRefusal } from "@ac-expo/utils";

type CheckoutRefusalsProps = {
  refusals: CartRefusal[];
  onBackToCart: () => void;
};

/**
 * Reasons the server refused the basket, shown on the checkout screen next to the
 * ticket each one belongs to. The visitor has left the cart behind at this point,
 * so the block also offers the way back to correct it.
 */
function CheckoutRefusals({ refusals, onBackToCart }: CheckoutRefusalsProps) {
  if (refusals.length === 0) {
    return null;
  }

  return (
    <div
      role="alert"
      className="flex flex-col gap-4 rounded-lg bg-white p-6"
    >
      <p className="text-sm font-semibold">Corrigez ces billets pour commander</p>
      <ul className="flex flex-col gap-3">
        {refusals.map((refusal) => (
          <li key={`${refusal.key}-${refusal.reason}`} className="flex flex-col">
            <span className="text-sm font-medium">{refusal.name}</span>
            <span className="text-sm text-red-500">{refusal.reason}</span>
          </li>
        ))}
      </ul>
      <Button
        type="button"
        variant="unstyled"
        size="fit"
        className="self-start text-sm font-semibold text-blue-500 hover:underline"
        onClick={onBackToCart}
      >
        Modifier mon panier
      </Button>
    </div>
  );
}

export default CheckoutRefusals;
